<!--@format-->
<template>
    <div class="gst-hotel-amenity d-flex flex-row align-center">
        <div class="gst-hotel-amenity__icon d-flex justify-center align-center">
            <IconRoomAmenity :id="itemWithPrice.id" />
        </div>
        <span class="gst-hotel-amenity__text">
            {{ itemWithPrice.name }}
        </span>
        <BaseTooltip
            v-if="itemWithPrice.tooltip"
            bottom
            :text="itemWithPrice.tooltip"
            class-content="gst-hotel-amenity__tooltip-content"
            class-activator="gst-hotel-amenity__tooltip-activator d-flex align-center justify-center ml-auto">
            <BaseIcon
                symbol-id="icons--help"
                :width="18"
                :height="18" />
        </BaseTooltip>
    </div>
</template>

<script>
import IconRoomAmenity from '@tenant/app/modules/hotel/components/icons/IconRoomAmenity';

export default {
    name: 'HotelAmenity',
    components: {
        IconRoomAmenity,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        itemWithPrice() {
            const { item } = this;
            if (!item.included && item.price) {
                const priceFormatted = this.$options.filters.currencyFilter(
                    item.price,
                    item.currency
                );
                const tooltip = `${item.name} ${priceFormatted}`;
                const name = this.$options.filters.appendCurrencySymbol(item.name, item.currency);

                return {
                    ...item,
                    name: name,
                    tooltip: tooltip,
                };
            }

            return item;
        },
    },
};
</script>

<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-hotel-amenity {
    background-color: theme-color('white');
    color: theme-color('success');

    .gst-hotel-amenity__text {
        padding-left: theme-spacing(2);
    }

    .gst-hotel-amenity__icon {
        min-height: 18px;

        svg {
            height: 18px;
            width: 18px;
        }
    }
}

@include mobile-only {
    .gst-hotel-amenity {
        display: flex;
        width: 100%;
        flex: 100%;
    }
}

.gst-hotel-amenity__tooltip-content.v-tooltip__content {
    width: auto !important;
}
</style>
